module.exports = __webpack_public_path__ + "static/media/Maf_banners-civilpenal.9f9f59a3.jpg";